import { ScreenLoading } from '@/components/loading';
import { ScreenError } from '@/components/screen-error';
import { ScreenAdminInventory } from '@/components/screens/admin-inventory-screen';
import { useApplications } from '@/hooks/use-applications';
import { useScreenProps } from '@/store/theme';

export function InternalPage() {
  const sp = useScreenProps();
  const { data: apps, isLoading, isError, error, refetch, isFetching } = useApplications();

  // Erro ANTES do loading: sem isso a tela fica em spinner infinito quando a
  // query falha (isLoading volta a false, mas `apps` segue undefined).
  if (isError && !apps) {
    return (
      <ScreenError
        error={error}
        onRetry={() => void refetch()}
        retrying={isFetching}
        active="internal"
        role="admin"
        title="Apps internos"
        subtitle="Aplicações de uso restrito da Masterboi"
      />
    );
  }
  if (isLoading || !apps) return <ScreenLoading dark={sp.dark} />;

  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenAdminInventory
        {...sp}
        apps={apps}
        active="internal"
        initialFilter="interno"
        title="Apps internos"
      />
    </div>
  );
}
